
    <ng-container *ngIf="value | filled">
      {{ value | format: 'lll' }}
    </ng-container>
  